module.exports = __webpack_public_path__ + "static/media/circle-banner.e8ed95a7.svg";